import {
    IonButton,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { User } from "../../../@types/user";
import { setDeselectUser } from "../../../store/profileDetail/profileDetail.reducer";
import { selectUsersSelected } from "../../../store/profileDetail/selector/selectUsersSelected";

export const AddUserSelected = () => {
    const dispatch = useDispatch();
    const selectedUsers: User[] = useSelector(selectUsersSelected);

    return (
        <IonContent>
            <IonListHeader>{selectedUsers.length} usuarios seleccionados</IonListHeader>
                <IonList>
                    {selectedUsers?.map((user: User) => (
                        <IonItem key={user.id}>
                            <IonLabel>{user.name}</IonLabel>
                            <IonButton onClick={() => dispatch(setDeselectUser(user))}>
                                <IonIcon icon={trashOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                </IonList>
        </IonContent>
    );
};